import React, { useContext, useEffect, useState } from 'react'
import { useFormContext, useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Icon, Table } from 'semantic-ui-react'
import { CoolFarmCropOptionsContext } from '../..'
import { FormFields } from '~/components/FormFields'

interface Props {
  index: number
  removeEnergy: (index: number) => void
}

const Energy: React.FC<Props> = ({ index, removeEnergy }) => {
  const { t } = useTranslation()
  const { control, setValue, formState: { touchedFields } } = useFormContext()
  const options = useContext(CoolFarmCropOptionsContext)

  const watchEnergyTypeId = useWatch({ control, name: `energyTypes[${index}].id` })

  const [units, setUnits] = useState([])

  const energyTypeOptions = options?.energyTypes?.map(type => ({
    key: type.id,
    value: type.id,
    text: type.label
  })) || []

  const cropEnergyCategories = options?.cropEnergyCategories?.map(type => ({
    key: type.key,
    value: type.key,
    text: type.label
  })) || []

  useEffect(() => {
    if (watchEnergyTypeId && index >= 0) {
      const energyTypeOption = options.energyTypes?.find(energyType => energyType.id === watchEnergyTypeId)
      setUnits(energyTypeOption.units?.map(unit => ({ value: unit.key, text: unit.label })) || [])
    }
    if(touchedFields?.energyTypes && touchedFields?.energyTypes[index]?.id) {
      setValue(`energyTypes[${index}].amountUnit`, '')
    }
  }, [watchEnergyTypeId])

  return <>
    <Table.Cell>
      <FormFields.Select
        control={control}
        name={`energyTypes[${index}].id`}
        rules={{
          required: true
        }}
        withoutAsterisk
        options={energyTypeOptions}
        placeholder={t('Select energy type')}
        noErrorMessage
      />
    </Table.Cell>
    <Table.Cell>
      <FormFields.Input
        control={control}
        name={`energyTypes[${index}].amount`}
        withoutAsterisk
        placeholder={t('Energy used')}
        typeInput='controled'
        rules={{
          required: true
        }}
        noErrorMessage
      />
    </Table.Cell>
    <Table.Cell>
      <FormFields.Select
        options={units}
        control={control}
        rules={{
          required: true
        }}
        name={`energyTypes[${index}].amountUnit`}
        withoutAsterisk
        placeholder={t('Unit')}
        noErrorMessage
      />
    </Table.Cell>
    <Table.Cell>
      <FormFields.Select
        control={control}
        rules={{
          required: true
        }}
        name={`energyTypes[${index}].category`}
        withoutAsterisk
        options={cropEnergyCategories}
        placeholder={t('Category')}
        noErrorMessage
      />
    </Table.Cell>
    <Table.Cell textAlign='center'>
      <Icon
        name='trash'
        color='red'
        style={{ cursor: 'pointer', fontSize: '1.3em' }}
        onClick={() => removeEnergy(index)}
      />
    </Table.Cell>
  </>
}
export default Energy